import { Component, Input, OnInit } from '@angular/core';

import { BaseSelectionList } from '../base/base-selection-list.component';
import { OrganizationsService } from './../../../../core/api/services/organizations.service';

@Component({
    selector: 'organization-selection-list',
    templateUrl: './organization-selection-list.component.html',
    standalone: false
})
export class OrganizationSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input('type') type:
    | 'organizations'
    | 'descendantAndItselfList'
    | 'children'
    | 'childrenAndItselfList'
    | 'descendantList'
    | 'organizationForCreateUser' = 'organizations';

  constructor(protected currentService: OrganizationsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'name';
    this.sortKey = 'id';

    if (!this.input_label) this.input_label = 'common.organizations';
  }

  getItems() {
    this.loading = true;

    switch (this.type) {
      // organizations
      // case "organizations":

      //     this.currentService.organizationsGetOrganizationsList()
      //       .pipe(this.baseSelectionSearchPipeOperators)
      //       .subscribe((items) => {
      //         this.items = items;
      //       })

      //   break;

      // descendantAndItselfList
      case 'descendantAndItselfList':
        this.currentService
          .organizationsGetOrganizationDescendantAndItselfList()
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items?.data;
          });

        break;

      // children
      // case "children":

      //     this.currentService.organizationsGetOrganizationChildrenList()
      //       .pipe(this.baseSelectionSearchPipeOperators)
      //       .subscribe((items) => {
      //         this.items = items;
      //       })

      //   break;

      // childrenAndItselfList
      case 'childrenAndItselfList':
        this.currentService
          .organizationsGetOrganizationChildrenAndItselfList()
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items?.data;
          });

        break;

      // descendantList
      case 'descendantList':
        this.currentService
          .organizationsGetOrganizationDescendantList()
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items?.data;
          });

        break;

      // organizationForCreateUser
      case 'organizationForCreateUser':
        this.currentService
          .organizationsGetOrganizationForCreateUser()
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items?.data;
          });

        break;
    }
  }
}
